import { Checkbox, DateDropdown, Field, SetFieldValue, TimeDropdown } from '../../gs-component-form';
import { FormBlockColumn, FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import { Field as FormikField } from 'formik';
import React, { useContext } from 'react';

import { ApiClientsContext } from '../components/ApiClientsContext';
import { AutoFocusableFields } from './interface';
import { DATE, TIME } from './helpers';

interface Props {
  setFieldValue: SetFieldValue;
  namePrefix?: string;
  showDate?: boolean;
  showHideDateCheckbox?: boolean;
  autoFocusField: AutoFocusableFields | undefined;
}

export const EventInfoForm: React.FC<Props> = ({
  setFieldValue,
  namePrefix = '',
  showDate = true,
  showHideDateCheckbox,
  autoFocusField,
}) => {
  const { eventType: type } = useContext(ApiClientsContext);
  const seeHideDateCheckbox = !!showHideDateCheckbox && (type === 'Ceremony' || type === 'WeddingDay');

  return (
    <>
      {type !== 'Ceremony' && (
        <FormBlockColumn>
          <FormikField
            data-testid="event_name"
            name={`${namePrefix}name`}
            label="Event Name*"
            component={Field}
            autoFocus={!autoFocusField}
          />
        </FormBlockColumn>
      )}
      {seeHideDateCheckbox && (
        <FormBlockColumn>
          <FormikField
            name={`${namePrefix}hideDate`}
            component={Checkbox}
            disabledText={`Hide Wedding Date and Display "To Be Announced" on Website`}
            enabledText={`Hide Wedding Date and Display "To Be Announced" on Website`}
          />
        </FormBlockColumn>
      )}
      {showDate && (
        <FormBlockColumn>
          <FormikField
            name={`${namePrefix}date`}
            setFieldValue={setFieldValue}
            label="Date"
            component={DateDropdown}
            readOnly={false}
            autoFocus={autoFocusField === DATE}
          />
        </FormBlockColumn>
      )}
      <FormRow>
        <FormColumn xs="12" md>
          <FormikField
            name={`${namePrefix}time`}
            label="Start Time"
            component={TimeDropdown}
            setFieldValue={setFieldValue}
            autoFocus={autoFocusField === TIME}
          />
        </FormColumn>
        <FormColumn xs="12" md>
          <FormikField
            name={`${namePrefix}endTime`}
            label="End Time"
            component={TimeDropdown}
            setFieldValue={setFieldValue}
          />
        </FormColumn>
      </FormRow>
    </>
  );
};
